import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

function Header() {
  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <img 
            src="https://firebasestorage.googleapis.com/v0/b/consulta-giovanile-di-ortona.appspot.com/o/logo_consulta.png?alt=media&token=dda986a6-79b4-4e89-bd3e-6893adbe6a11" 
            alt="Consulta Giovanile di Ortona Logo" 
          />
          <h1>Consulta Giovanile di Ortona</h1>
        </div>
        <nav className="nav-menu">
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">Chi Siamo</Link></li>
            <li><Link to="/articles">Articoli</Link></li>
            <li><Link to="/events">Eventi</Link></li>
            <li><Link to="/contact">Contatti</Link></li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
